import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {_GlobalConstants} from '../../../services/globalConstants.service';
import {_UsersService} from "../../../services/users.service";
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {Observable} from "rxjs/Observable";

declare var jQuery: any;
declare var $: any;
declare var defaultGridViewSettings;

@Component({
  selector: 'fx-recommendations-h',
  templateUrl: './fx-recommendations-h.component.html',
  styleUrls: ['./fx-recommendations-h.component.css'],
})

export class FXOrderRecommendationsHistory implements OnInit, OnDestroy {

  private subscription: any;
  private users: any;
  private accounts: any;
  private liquidityProviders: any;


  constructor(private titleService: Title, private constants: _GlobalConstants, private usersService: _UsersService, private referenceData: _ReferenceDataService) {
  }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | FX Order Recommendation Summary");

    this.subscription = Observable.forkJoin(this.usersService.getUsers(), this.referenceData.getAccounts(), this.referenceData.getLiquidityProviders()).subscribe((res: Array<any>) => {
      this.users = res[0];
      this.accounts = res[1];
      this.liquidityProviders = res[2];
      this.ready();
    });
  }

  ready() {
    let users = this.users;
    let accounts = this.accounts;
    let liquidityProviders = this.liquidityProviders;

    // init main tab widgets.
    var initrowdetails = function (index, parentElement, gridElement, datarecord) {

      // Allocations
      var sourceAllocations = {
        localdata: datarecord.allocations,
        datatype: "json",
        datafields: [{
          name: 'accountId',
          type: 'string'
        }, {
          name : 'accountDisplayName',
          type : 'string',
          value: 'accountId',
          values: {
            source: accounts,
            value: 'accountId',
            name: 'displayName'
          }
        }, {
          name: 'currency',
          type: 'string'
        }, {
          name: 'quantity',
          type: 'string'
        }]
      };
      var settingsAllocations = defaultGridViewSettings("#jqxGridAllocations", sourceAllocations);
      settingsAllocations.width = '97%';
      settingsAllocations.height = '99%';
      settingsAllocations.columns = [{
        text: 'Account',
        columntype: 'textbox',
        datafield: 'accountDisplayName',
        width: '15%'
      }, {
        text: 'Ccy',
        columntype: 'textbox',
        datafield: 'currency',
        width: '10%'
      }, {
        text: 'Quantity',
        columntype: 'textbox',
        datafield: 'quantity',
        width: '20%'
      }];

      var gridDiv = $($(parentElement).children()[0]);
      $(gridDiv).jqxGrid(settingsAllocations);
    }

    // initialize jqxGrid
    var sourceFXOrders = {
      datatype: "json",
      datafields: [{
        name: 'eventTimestamp',
        type: 'date',
        format: 'yyyy-MM-dd HH:mm:ss.fff'
      }, {
        name: 'eventUserId',
        type: 'string'
      }, {
        name: 'eventUserDisplayName',
        type: 'string',
        value: 'eventUserId',
        values: {
          source: this.users,
          value: 'userId',
          name: 'displayName'
        }
      }, {
        name: 'eventIpAddress',
        type: 'string'
      }, {
        name: 'orderId',
        type: 'string'
      }, {
        name: 'eventAction',
        type: 'string'
      }, {
        name: 'eventActionDisplayName',
        type: 'string',
        value: 'eventAction',
        values: {
          source: this.constants.getTranslatedValues('resources.fxOrderEvent.action'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'orderState',
        type: 'string'
      }, {
        name: 'orderStateDisplayName',
        type: 'string',
        value: 'orderState',
        values: {
          source: this.constants.getTranslatedValues('resources.orderUpdate.state'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'ruleMatchEventId',
        type: 'string'
      }, {
        name: 'externalOrderId',
        type: 'string'
      }, {
        name: 'updateId',
        type: 'string'
      }, {
        name: 'updateTimestamp',
        type: 'date',
        format: 'yyyy-MM-dd HH:mm:ss.fff'
      }, {
        name: 'currencyPair',
        type: 'string'
      }, {
        name: 'currency',
        type: 'string'
      }, {
        name: 'valueDate',
        type: 'date',
        format: 'yyyy-MM-dd'
      }, {
        name: 'liquidityProviderId',
        type: 'string'
      }, {
        name: 'liquidityProviderDisplay',
        type: 'string',
        value: 'liquidityProviderId',
        values: {
          source: liquidityProviders,
          value: 'liquidityProviderId',
          name: 'displayName'
        }
      }, {
        name: 'contractType',
        type: 'string'
      }, {
        name: 'contractTypeDisplayName',
        type: 'string',
        value: 'contractType',
        values: {
          source: this.constants.getTranslatedValues('resources.fxInstrument.type'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'orderType',
        type: 'string'
      }, {
        name: 'orderTypeDisplayName',
        type: 'string',
        value: 'orderType',
        values: {
          source: this.constants.getTranslatedValues('resources.order.type'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'positionAction',
        type: 'string'
      }, {
        name: 'sideDisplayName',
        type: 'string',
        value: 'positionAction',
        values: {
          source: this.constants.getTranslatedValues('resources.order.side'),
          value: 'value',
          name: 'display'
        }
      }, {
        name: 'orderQuantity',
        type: 'string'
      }, {
        name: 'orderSpotPrice',
        type: 'string'
      }, {
        name: 'orderForwardPoints',
        type: 'string'
      }, {
        name: 'orderOutrightPrice',
        type: 'string'
      }, {
        name: 'quoteId',
        type: 'string'
      }, {
        name: 'traderId',
        type: '100'
      }, {
        name: 'quantityExecuted',
        type: 'string'
      }, {
        name: 'fillQuantity',
        type: 'string'
      }, {
        name: 'fillSpotPrice',
        type: 'string'
      }, {
        name: 'fillForwardPoints',
        type: 'string'
      }, {
        name: 'fillOutrightPrice',
        width: '100'
      }, {
        name: 'fillCounterParty',
        type: 'string'
      }, {
        name: 'allocations',
        type: 'array'
      }],
      id: 'eventID',
      url: '/ajax/fx-orders/events',
      type: 'GET',
      async: true
    };
    var settingsFXOrders = defaultGridViewSettings("#jqxGrid", sourceFXOrders);
    settingsFXOrders.columns = [{
      text: 'Timestamp',
      columntype: 'datetimeinput',
      datafield: 'eventTimestamp',
      cellsformat: 'MM/dd/yyyy HH:mm:ss.fff',
      width: '160'
    }, {
      text: 'User',
      columntype: 'textbox',
      datafield: 'eventUserDisplayName',
      width: '100'
    }, {
      text: 'IP Address',
      columntype: 'textbox',
      datafield: 'eventIpAddress',
      width: '80'
    }, {
      text: 'Internal Order ID',
      columntype: 'textbox',
      datafield: 'orderId',
      width: '130'
    }, {
      text: 'Update Type',
      columntype: 'textbox',
      datafield: 'eventActionDisplayName',
      width: '200'
    }, {
      text: 'Order State',
      columntype: 'textbox',
      datafield: 'orderStateDisplayName',
      width: '100'
    }, {
      text: 'External Order ID',
      columntype: 'textbox',
      datafield: 'externalOrderId',
      width: '130'
    }, {
      text: 'External Trade ID',
      columntype: 'textbox',
      datafield: 'updateId',
      width: '130'
    }, {
      text: 'External Timestamp',
      columntype: 'datetimeinput',
      cellsformat: 'MM/dd/yyyy HH:mm:ss.fff',
      datafield: 'updateTimestamp',
      width: '160'
    }, {
      text: 'Ccy Pair',
      columntype: 'textbox',
      datafield: 'currencyPair',
      width: '80'
    }, {
      text: 'Ccy',
      columntype: 'textbox',
      datafield: 'currency',
      width: '50'
    }, {
      text: 'Value Date',
      columntype: 'datetimeinput',
      cellsformat: 'yyyy-MMM-dd',
      datafield: 'valueDate',
      width: '80'
    }, {
      text: 'Broker',
      columntype: 'textbox',
      datafield: 'liquidityProviderDisplay',
      width: '80'
    }, {
      text: 'Contract Type',
      columntype: 'textbox',
      datafield: 'contractTypeDisplayName',
      width: '100'
    }, {
      text: 'Order Type',
      columntype: 'textbox',
      datafield: 'orderTypeDisplayName',
      width: '100'
    }, {
      text: 'Side',
      columntype: 'textbox',
      datafield: 'sideDisplayName',
      width: '50'
    }, {
      text: 'Order Quantity',
      columntype: 'textbox',
      datafield: 'orderQuantity',
      width: '100'
    }, {
      text: 'Order Spot Px',
      columntype: 'textbox',
      datafield: 'orderSpotPrice',
      width: '120'
    }, {
      text: 'Order Fwd Pts',
      columntype: 'textbox',
      datafield: 'orderForwardPoints',
      width: '100'
    }, {
      text: 'Order Outright Px',
      columntype: 'textbox',
      datafield: 'orderOutrightPrice',
      width: '150'
    }, {
      text: 'Quote ID',
      columntype: 'textbox',
      datafield: 'quoteId',
      width: '100'
    }, {
      text: 'Trader ID',
      columntype: 'textbox',
      datafield: 'traderId',
      width: '100'
    }, {
      text: 'Quantity Executed',
      columntype: 'textbox',
      datafield: 'quantityExecuted',
      width: '100'
    }, {
      text: 'Fill Quantity',
      columntype: 'textbox',
      datafield: 'fillQuantity',
      width: '100'
    }, {
      text: 'Fill Spot Px',
      columntype: 'textbox',
      datafield: 'fillSpotPrice',
      width: '120'
    }, {
      text: 'Fill Fwd Pts',
      columntype: 'textbox',
      datafield: 'fillForwardPoints',
      width: '100'
    }, {
      text: 'Fill Outright Px',
      columntype: 'textbox',
      datafield: 'fillOutrightPrice',
      width: '100'
    }, {
      text: 'Fill Counter Party',
      columntype: 'textbox',
      datafield: 'fillCounterParty',
      width: '100'
    }];
    settingsFXOrders.rowdetails = true;
    settingsFXOrders.initrowdetails = initrowdetails;
    settingsFXOrders.rowdetailstemplate = {
      rowdetails: "<div id='jqxGridAllocations' style='overflow: hidden;'></div>",
      rowdetailsheight: 300,
      rowdetailshidden: true
    };

    $("#jqxGrid").jqxGrid(settingsFXOrders);

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/fx-recommendations-h/fx-recommendations-h.component.ts